import React from "react";

export default (props) => (
  <svg width="21" height="25" viewBox="0 0 21 25" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.778 0H21v25h-6.222zM0 0h6.222v25H0z"/></svg>
)